import { type LandingContentsDistancesInner } from '@clients/ContentApi';

export default class LandingDistance {
    constructor(data: LandingContentsDistancesInner) {
        if (data.unit === 's') {
            const min = +(data.value ?? '0') % 60;
            const hour = Math.floor(+(data.value ?? '0') / 60);
            this.distance =
                (hour ? `${hour} ساعت` : '') +
                (hour && min ? ' و ' : '') +
                (min ? `${min} دقیقه` : '');
        } else if (data.unit === 'km') {
            this.distance = `${data.value} کیلومتر`;
        }
        this.city = data.cityName ?? '';
        this.id = data.cityCode ?? '';
    }

    city: string;
    distance = '';
    id: string;

    toJSON() {
        return { ...this };
    }
}
